var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Match"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3956"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 45",
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#FF5000",
    stroke: "#FF5000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9935 7.51112C13.9486 7.4659 13.8953 7.43001 13.8365 7.40551C13.7777 7.38102 13.7146 7.36841 13.6509 7.36841C13.5872 7.36841 13.5242 7.38102 13.4654 7.40551C13.4066 7.43001 13.3532 7.4659 13.3084 7.51112L9.71409 11.1102L8.204 9.59533C8.15743 9.55034 8.10246 9.51497 8.04222 9.49124C7.98199 9.4675 7.91766 9.45585 7.85293 9.45697C7.78819 9.45809 7.72431 9.47195 7.66493 9.49776C7.60555 9.52357 7.55183 9.56082 7.50685 9.60739C7.46187 9.65396 7.4265 9.70893 7.40276 9.76917C7.37902 9.8294 7.36738 9.89373 7.3685 9.95846C7.36962 10.0232 7.38348 10.0871 7.40929 10.1465C7.43509 10.2058 7.47234 10.2596 7.51891 10.3045L9.37154 12.1572C9.41639 12.2024 9.46975 12.2383 9.52855 12.2628C9.58734 12.2873 9.6504 12.2999 9.71409 12.2999C9.77778 12.2999 9.84084 12.2873 9.89963 12.2628C9.95842 12.2383 10.0118 12.2024 10.0566 12.1572L13.9935 8.22033C14.0424 8.17515 14.0815 8.12032 14.1083 8.05929C14.135 7.99826 14.1488 7.93235 14.1488 7.86572C14.1488 7.7991 14.135 7.73319 14.1083 7.67216C14.0815 7.61113 14.0424 7.5563 13.9935 7.51112Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatch);
export default __webpack_public_path__ + "static/media/match.4b0948b5e508007ff9d30a9c0ee10781.svg";
export { ForwardRef as ReactComponent };